export class LoadTestPlans {
	static readonly type = '[TestPlans/Api] Load test plans';
	constructor(public projectId: string) {}
}

export class CreateTestPlan {
	static readonly type = '[TestPlans/Api] Create test plan';
	constructor(public payload: CreateTestPlan) {}
}
